import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/tfa_google');

export default function TFAGoogleHint() {
  return <Content />;
}
